import React from "react";
import { formatDate } from "../../components/helpers/formatDate";
import { getNoteCreatorName } from "../../components/helpers/getNoteCreatorName";

/**
 * Mobile note detail view with full content.
 */
export default function MobileNoteDetail({ note, onBack }) {
  if (!note) return null;

  return (
    <div className="mobile-note-detail">
      <button className="mobile-back-btn" onClick={onBack}>
        ← Back to notes
      </button>
      <div className="mobile-note-detail__content">
        <div className="mobile-field">
          <div className="mobile-field__label">Date</div>
          <div className="mobile-field__value">{formatDate(note.date_note)}</div>
        </div>
        <div className="mobile-field">
          <div className="mobile-field__label">Type</div>
          <div className="mobile-field__value">{note.type || "Note"}</div>
        </div>
        <div className="mobile-field">
          <div className="mobile-field__label">Created by</div>
          <div className="mobile-field__value">
            {getNoteCreatorName(note)}
          </div>
        </div>
        <div className="mobile-field">
          <div className="mobile-field__label">Subject</div>
          <div className="mobile-field__value">{note.subject}</div>
        </div>
        <div className="mobile-note-detail__body">
          <div className="mobile-field__label">Note</div>
          <div className="mobile-note-detail__text">{note.note}</div>
        </div>
      </div>
    </div>
  );
}

